import { create } from "zustand";

const useStore = create((set) => ({
  user: null,
  setUser: (user) => set(() => ({ user })),
}));

export default useStore;
